export default function animationPrenatalBanner(element) {
    const berries = Array.from(element.querySelectorAll("[data-prenatal-berry]"));

    if (!berries.length) {
        return;
    }

    let ticking = false;

    const updateParallax = () => {
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.max(-1, Math.min(1, (viewportHeight * 0.5 - rect.top) / viewportHeight));

        berries.forEach((berry, index) => {
            const depth = parseFloat(berry.dataset.depth || "0.2");
            const mobileFactor = window.matchMedia("(max-width: 700px)").matches ? 0.28 : 1;
            const direction = index % 2 === 0 ? -1 : 1;
            const y = progress * depth * 95 * mobileFactor;
            const x = progress * depth * 34 * direction * mobileFactor;
            berry.style.setProperty("--parallax-x", `${x.toFixed(2)}px`);
            berry.style.setProperty("--parallax-y", `${y.toFixed(2)}px`);
        });

        ticking = false;
    };

    const requestUpdate = () => {
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    };

    updateParallax();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
}
